import { default as _91_46_46_46all_934vCe6jBBh6Meta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/[...all].vue?macro=true";
import { default as authIZ2xVQin3DMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/auth.vue?macro=true";
import { default as indexpg5KB3tHQ3Meta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/checkout/index.vue?macro=true";
import { default as indexE1zEeFsGknMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/email-history/index.vue?macro=true";
import { default as indexYrJXMem22GMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/en/index.vue?macro=true";
import { default as index2odsXPONsYMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/id-ID/index.vue?macro=true";
import { default as indexK9XoaO9J4uMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/index.vue?macro=true";
import { default as indexb0byrwoTyyMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/th-TH/index.vue?macro=true";
import { default as indexEkmKg5G44vMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/index.vue?macro=true";
import { default as authJbSOfzqXk4Meta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/login/auth.vue?macro=true";
import { default as authXuMK5VyQyTMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/logout/auth.vue?macro=true";
import { default as indexjKq4I5b9dMMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/my-cards/index.vue?macro=true";
import { default as _91id_932oX3kobVMlMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/payment-callback/[id].vue?macro=true";
import { default as indexC1yNbCGYpjMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/products/index.vue?macro=true";
import { default as _91orderId_93ytZnsjxduLMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/result/[orderId].vue?macro=true";
import { default as indexVWlGnEvpy1Meta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/terms-of-sale/index.vue?macro=true";
import { default as indexiK7osB8u3qMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/transaction-history/index.vue?macro=true";
import { default as indexwwgjhuQ5j1Meta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/en/index.vue?macro=true";
import { default as indexLpqFkFVO1jMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/id-ID/index.vue?macro=true";
import { default as index3mBpPBmt2ZMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/index.vue?macro=true";
import { default as indexs6UGoPIhGXMeta } from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/th-TH/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46all_934vCe6jBBh6Meta?.name ?? "all",
    path: _91_46_46_46all_934vCe6jBBh6Meta?.path ?? "/:all(.*)*",
    children: [],
    meta: _91_46_46_46all_934vCe6jBBh6Meta || {},
    alias: _91_46_46_46all_934vCe6jBBh6Meta?.alias || [],
    redirect: _91_46_46_46all_934vCe6jBBh6Meta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/[...all].vue").then(m => m.default || m)
  },
  {
    name: authIZ2xVQin3DMeta?.name ?? "auth",
    path: authIZ2xVQin3DMeta?.path ?? "/auth",
    children: [],
    meta: authIZ2xVQin3DMeta || {},
    alias: authIZ2xVQin3DMeta?.alias || [],
    redirect: authIZ2xVQin3DMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/auth.vue").then(m => m.default || m)
  },
  {
    name: indexpg5KB3tHQ3Meta?.name ?? "checkout",
    path: indexpg5KB3tHQ3Meta?.path ?? "/checkout",
    children: [],
    meta: indexpg5KB3tHQ3Meta || {},
    alias: indexpg5KB3tHQ3Meta?.alias || [],
    redirect: indexpg5KB3tHQ3Meta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexE1zEeFsGknMeta?.name ?? "email-history",
    path: indexE1zEeFsGknMeta?.path ?? "/email-history",
    children: [],
    meta: indexE1zEeFsGknMeta || {},
    alias: indexE1zEeFsGknMeta?.alias || [],
    redirect: indexE1zEeFsGknMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/email-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexYrJXMem22GMeta?.name ?? "faq-en",
    path: indexYrJXMem22GMeta?.path ?? "/faq/en",
    children: [],
    meta: indexYrJXMem22GMeta || {},
    alias: indexYrJXMem22GMeta?.alias || [],
    redirect: indexYrJXMem22GMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/en/index.vue").then(m => m.default || m)
  },
  {
    name: index2odsXPONsYMeta?.name ?? "faq-id-ID",
    path: index2odsXPONsYMeta?.path ?? "/faq/id-ID",
    children: [],
    meta: index2odsXPONsYMeta || {},
    alias: index2odsXPONsYMeta?.alias || [],
    redirect: index2odsXPONsYMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/id-ID/index.vue").then(m => m.default || m)
  },
  {
    name: indexK9XoaO9J4uMeta?.name ?? "faq",
    path: indexK9XoaO9J4uMeta?.path ?? "/faq",
    children: [],
    meta: indexK9XoaO9J4uMeta || {},
    alias: indexK9XoaO9J4uMeta?.alias || [],
    redirect: indexK9XoaO9J4uMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/index.vue").then(m => m.default || m)
  },
  {
    name: indexb0byrwoTyyMeta?.name ?? "faq-th-TH",
    path: indexb0byrwoTyyMeta?.path ?? "/faq/th-TH",
    children: [],
    meta: indexb0byrwoTyyMeta || {},
    alias: indexb0byrwoTyyMeta?.alias || [],
    redirect: indexb0byrwoTyyMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/faq/th-TH/index.vue").then(m => m.default || m)
  },
  {
    name: indexEkmKg5G44vMeta?.name ?? "index",
    path: indexEkmKg5G44vMeta?.path ?? "/",
    children: [],
    meta: indexEkmKg5G44vMeta || {},
    alias: indexEkmKg5G44vMeta?.alias || [],
    redirect: indexEkmKg5G44vMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/index.vue").then(m => m.default || m)
  },
  {
    name: authJbSOfzqXk4Meta?.name ?? "login-auth",
    path: authJbSOfzqXk4Meta?.path ?? "/login/auth",
    children: [],
    meta: authJbSOfzqXk4Meta || {},
    alias: authJbSOfzqXk4Meta?.alias || [],
    redirect: authJbSOfzqXk4Meta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/login/auth.vue").then(m => m.default || m)
  },
  {
    name: authXuMK5VyQyTMeta?.name ?? "logout-auth",
    path: authXuMK5VyQyTMeta?.path ?? "/logout/auth",
    children: [],
    meta: authXuMK5VyQyTMeta || {},
    alias: authXuMK5VyQyTMeta?.alias || [],
    redirect: authXuMK5VyQyTMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/logout/auth.vue").then(m => m.default || m)
  },
  {
    name: indexjKq4I5b9dMMeta?.name ?? "my-cards",
    path: indexjKq4I5b9dMMeta?.path ?? "/my-cards",
    children: [],
    meta: indexjKq4I5b9dMMeta || {},
    alias: indexjKq4I5b9dMMeta?.alias || [],
    redirect: indexjKq4I5b9dMMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/my-cards/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_932oX3kobVMlMeta?.name ?? "payment-callback-id",
    path: _91id_932oX3kobVMlMeta?.path ?? "/payment-callback/:id",
    children: [],
    meta: _91id_932oX3kobVMlMeta || {},
    alias: _91id_932oX3kobVMlMeta?.alias || [],
    redirect: _91id_932oX3kobVMlMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/payment-callback/[id].vue").then(m => m.default || m)
  },
  {
    name: indexC1yNbCGYpjMeta?.name ?? "products",
    path: indexC1yNbCGYpjMeta?.path ?? "/products",
    children: [],
    meta: indexC1yNbCGYpjMeta || {},
    alias: indexC1yNbCGYpjMeta?.alias || [],
    redirect: indexC1yNbCGYpjMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: _91orderId_93ytZnsjxduLMeta?.name ?? "result-orderId",
    path: _91orderId_93ytZnsjxduLMeta?.path ?? "/result/:orderId",
    children: [],
    meta: _91orderId_93ytZnsjxduLMeta || {},
    alias: _91orderId_93ytZnsjxduLMeta?.alias || [],
    redirect: _91orderId_93ytZnsjxduLMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/result/[orderId].vue").then(m => m.default || m)
  },
  {
    name: indexVWlGnEvpy1Meta?.name ?? "terms-of-sale",
    path: indexVWlGnEvpy1Meta?.path ?? "/terms-of-sale",
    children: [],
    meta: indexVWlGnEvpy1Meta || {},
    alias: indexVWlGnEvpy1Meta?.alias || [],
    redirect: indexVWlGnEvpy1Meta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/terms-of-sale/index.vue").then(m => m.default || m)
  },
  {
    name: indexiK7osB8u3qMeta?.name ?? "transaction-history",
    path: indexiK7osB8u3qMeta?.path ?? "/transaction-history",
    children: [],
    meta: indexiK7osB8u3qMeta || {},
    alias: indexiK7osB8u3qMeta?.alias || [],
    redirect: indexiK7osB8u3qMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexwwgjhuQ5j1Meta?.name ?? "user-guide-en",
    path: indexwwgjhuQ5j1Meta?.path ?? "/user-guide/en",
    children: [],
    meta: indexwwgjhuQ5j1Meta || {},
    alias: indexwwgjhuQ5j1Meta?.alias || [],
    redirect: indexwwgjhuQ5j1Meta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/en/index.vue").then(m => m.default || m)
  },
  {
    name: indexLpqFkFVO1jMeta?.name ?? "user-guide-id-ID",
    path: indexLpqFkFVO1jMeta?.path ?? "/user-guide/id-ID",
    children: [],
    meta: indexLpqFkFVO1jMeta || {},
    alias: indexLpqFkFVO1jMeta?.alias || [],
    redirect: indexLpqFkFVO1jMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/id-ID/index.vue").then(m => m.default || m)
  },
  {
    name: index3mBpPBmt2ZMeta?.name ?? "user-guide",
    path: index3mBpPBmt2ZMeta?.path ?? "/user-guide",
    children: [],
    meta: index3mBpPBmt2ZMeta || {},
    alias: index3mBpPBmt2ZMeta?.alias || [],
    redirect: index3mBpPBmt2ZMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/index.vue").then(m => m.default || m)
  },
  {
    name: indexs6UGoPIhGXMeta?.name ?? "user-guide-th-TH",
    path: indexs6UGoPIhGXMeta?.path ?? "/user-guide/th-TH",
    children: [],
    meta: indexs6UGoPIhGXMeta || {},
    alias: indexs6UGoPIhGXMeta?.alias || [],
    redirect: indexs6UGoPIhGXMeta?.redirect || undefined,
    component: () => import("/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/pages/user-guide/th-TH/index.vue").then(m => m.default || m)
  }
]